import api from "./index";
import { modelApi } from "./modelIndex";

export const createProject = async (projectData) => {
  const { projectName, projectDescription } = projectData;
  const data = {
    name: projectName,
    description: projectDescription,
  };
  try {
    const response = await api.post("/api/project-managers", data);
    return response.data;
  } catch (error) {
    console.error("프로젝트 생성 실패:", error);
    throw error;
  }
};

export const getProjectList = async () => {
  try {
    const response = await api.get("/api/project-managers");
    return response.data;
  } catch (error) {
    console.error("프로젝트 목록 조회 실패:", error);
    throw error;
  }
};

export const getTaskList = async (projectId, accessType) => {
  try {
    const response = await api.get(`/api/projects/${projectId}/list`);
    if (accessType === "COMPANY_INTERNAL") {
      response.data = response.data.filter(
        (project) => project.accessType === "COMPANY_INTERNAL",
      );
    } else {
      response.data = response.data.filter(
        (project) => project.accessType === "PUBLIC",
      );
    }
    return response.data;
  } catch (error) {
    console.error("태스크 목록 조회 실패:", error);
    throw error;
  }
};

export const fileUploadInit = async (fileName, fileSize) => {
  const data = {
    filename: fileName,
    fileSize: fileSize,
  };
  try {
    const response = await api.post("/api/files/upload/init", data);
    return response.data;
  } catch (error) {
    console.error("파일 업로드 초기화 실패:", error);
    throw error;
  }
};

export const fileUploadChunk = async (fileId, chunkNumber, chunkData) => {
  try {
    const formData = new FormData();

    formData.append("fileId", fileId.toString());
    formData.append("chunkNumber", chunkNumber.toString());
    formData.append("chunk", new Blob([chunkData]), `chunk_${chunkNumber}`);

    const response = await api.post("/api/files/upload/chunk", formData, {
      headers: {
        "Content-Type": undefined, // Content-Type 헤더 제거
      },
    });
    return response.data;
  } catch (error) {
    console.error("파일 업로드 청크 실패:", error);

    throw error;
  }
};

export const completeUpload = async (fileId) => {
  try {
    const response = await api.post(`/api/files/upload/${fileId}/complete`);
    return response.data;
  } catch (error) {
    console.error("파일 업로드 완료 실패:", error);
    throw error;
  }
};

export const createProjectTask = async (bucket_name, object_name) => {
  const data = {
    bucket_name: bucket_name,
    object_name: object_name,
  };
  try {
    const response = await modelApi.post("/api/pdal/stats", data);
    return response.data;
  } catch (error) {
    console.error("프로젝트 생성 실패:", error);
    throw error;
  }
};

const PDAL_JOB_POLL_INTERVAL_MS = 5000;
const PDAL_JOB_MAX_WAIT_MS = 30 * 60 * 1000; // 30분

export const getPdalJobStatus = async (jobId) => {
  const response = await modelApi.get(`/api/pdal/jobs/${jobId}`);
  return response.data;
};

export const createProjectTaskPipeline = async (pipelineData) => {
  const data = pipelineData.pipeline;
  try {
    // 작업 요청 → 즉시 job_id 반환 (타임아웃 없음)
    const response = await modelApi.post("/api/pdal/process-with-output", data);
    const { job_id } = response.data;

    // 완료될 때까지 폴링
    const startTime = Date.now();
    while (Date.now() - startTime < PDAL_JOB_MAX_WAIT_MS) {
      const job = await getPdalJobStatus(job_id);
      if (job.status === "COMPLETED") return job.result;
      if (job.status === "FAILED") throw new Error(job.error || "처리 실패");
      await new Promise((resolve) => setTimeout(resolve, PDAL_JOB_POLL_INTERVAL_MS));
    }
    throw new Error("처리 타임아웃 (30분 초과)");
  } catch (error) {
    console.error("파이프라인 처리 실패:", error);
    throw error;
  }
};

export const createProjectTaskToDB = async (projectData, fileId, id) => {
  if (!projectData.projectName || !fileId || !id) {
    throw new Error("필수 데이터가 누락되었습니다.");
  }
  const data = {
    name: projectData.projectName,
    description: projectData.projectDescription,
    projectManagerId: id,
    fileId: fileId,
    accessType: projectData.viewPermission,
  };
  try {
    const response = await api.post("/api/projects", data);
    return response.data;
  } catch (error) {
    console.error("프로젝트 생성 실패:", error);
    throw error;
  }
};

export const confirmFilteredResult = async () => {
  const bucket_name = localStorage.getItem("bucketName");
  const object_name = localStorage.getItem("objectName");
  const output_bucket_name = localStorage.getItem("outputBucket");
  const output_object_name = localStorage.getItem("outputObject");
  const data = {
    bucket_name: bucket_name,
    object_name: object_name,
    output_bucket: output_bucket_name,
    output_object: output_object_name,
  };

  try {
    const response = await modelApi.post(
      "/api/pdal/confirm-filtered-result",
      data,
    );
    return response.data;
  } catch (error) {
    console.error("프로젝트 생성 실패:", error);
    throw error;
  }
};

export const sendZStatsToDB = async (zStats, fileId) => {
  const data = {
    convertZ: zStats,
  };
  try {
    const response = await api.put(`/api/files/${fileId}/convert-z`, data);
    return response.data;
  } catch (error) {
    console.error("Z 통계 데이터 저장 실패:", error);
    throw error;
  }
};

export const conversionFile = async (type, EPSG) => {
  const fileId = localStorage.getItem("fileId");

  const data = {
    fileId: fileId,
    conversionType: type,
    inputSrs: EPSG,
  };

  try {
    const response = await api.post("/api/files/conversion/start", data);
    return response.data;
  } catch (error) {
    console.error("파일 변환 실패:", error);
    throw error;
  }
};

export const getConversionJobStatus = async (jobId) => {
  const response = await api.get(`/api/files/conversion/jobs/${jobId}`);
  return response.data;
};

export const getzStats = async (fileId) => {
  const response = await api.get(`/api/files/${fileId}/convert-z`);
  return response.data;
};

// export const getProjectData = async () => {
//   const fileId = localStorage.getItem("fileId");
//   const response = await api.get(`/api/files/${fileId}`);
//   return response.data;
// };

export const getTileset = async (fileId, type) => {
  try {
    const response = await api.get(`/api/files/${type}/${fileId}/urls`);
    return response.data;
  } catch (error) {
    console.error("타일셋 조회 실패:", error);
    throw error;
  }
};

export const MapSearch = async (address) => {
  const API_KEY = process.env.REACT_APP_NAVER_MAP_API_KEY;

  try {
    const response = await api.get(
      `/api/geocoding/address-to-coordinates?address=${address}`,
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteTask = async (id) => {
  const data = {
    deleteId: [id],
  };

  try {
    const response = await api.delete(`/api/projects`, {
      data: data, // 또는 { data }
    });
    return response.data;
  } catch (error) {
    console.error("태스크 삭제 실패:", error);
    throw error;
  }
};

export const savePath = async (pathData) => {
  try {
    const response = await api.post("/api/projects/waypoints", pathData);
    return response.data;
  } catch (error) {
    console.error("경로 저장 실패:", error);
    throw error;
  }
};

export const getPathList = async (projectId) => {
  try {
    const response = await api.get(`/api/projects/waypoints/${projectId}`);
    return response.data;
  } catch (error) {
    console.error("경로 목록 조회 실패:", error);
    throw error;
  }
};

export const getPathData = async (pathId, waypointId) => {
  try {
    const response = await api.get(
      `/api/projects/waypoints/${pathId}/${waypointId}`,
    );
    return response.data;
  } catch (error) {
    console.error("경로 조회 실패:", error);
    throw error;
  }
};

export const deletePath = async (waypointId) => {
  try {
    const response = await api.delete(`/api/projects/waypoints/${waypointId}`);
    return response.data;
  } catch (error) {
    console.error("경로 삭제 실패:", error);
    throw error;
  }
};

export const getFilteredImage = async (outputBucket, outputObject) => {
  const object = {
    bucketName: outputBucket,
    objectName: outputObject,
  };
  try {
    const response = await modelApi.post(
      `/api/minio-outlier/las-to-image`,
      object,
      {
        responseType: "blob",
      },
    );
    return URL.createObjectURL(response.data);
  } catch (error) {
    console.error("필터링 이미지 조회 실패:", error);
    throw error;
  }
};

export const getFilteredFile = async (outputBucket, outputObject) => {
  const object = {
    bucketName: outputBucket,
    objectName: outputObject,
  };
  try {
    const response = await api.post(`/api/files/minio/presigned-url`, object);
    return response.data;
  } catch (error) {
    console.error("필터링 파일 조회 실패:", error);
    throw error;
  }
};

export const postProjectMEdit = async (
  projectName,
  projectDescription,
  projectManagerId,
) => {
  const data = {
    name: projectName,
    description: projectDescription,
  };
  try {
    const response = await api.put(
      `/api/project-managers/${projectManagerId}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("프로젝트 수정 실패:", error);
    throw error;
  }
};

export const patchProjectEdit = async (
  projectName,
  projectDescription,
  fileId,
  accessType,
  projectId,
) => {
  const data = {
    name: projectName,
    description: projectDescription,
    fileId: fileId,
    accessType: accessType,
  };

  try {
    const response = await api.patch(`/api/projects/${projectId}`, data);
    return response.data;
  } catch (error) {
    console.error("프로젝트 수정 실패:", error);
  }
};

export const deleteProjectManager = async (projectManagerId) => {
  try {
    const response = await api.delete(
      `/api/project-managers/${projectManagerId}`,
    );
    return response.data;
  } catch (error) {
    console.error("프로젝트 매니저 삭제 실패:", error);
    throw error;
  }
};
